module.exports = __webpack_public_path__ + "img/109056.f63156a1.png";